/* unplugin-vue-components disabled */import { render } from "./ResetQuizButton.vue?vue&type=template&id=4bd488bc&scoped=true&ts=true"
import script from "./ResetQuizButton.vue?vue&type=script&lang=ts"
export * from "./ResetQuizButton.vue?vue&type=script&lang=ts"

import "./ResetQuizButton.vue?vue&type=style&index=0&id=4bd488bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd488bc"]])

export default __exports__